"use client";

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { galleryItems } from "../../config/gallery";

export default function GalleryMain() {
  useEffect(() => {
    document.body.classList.add("route-gallery");
    return () => document.body.classList.remove("route-gallery");
  }, []);

  return (
    <section className="gallery-one">
      <div className="container">
        <div className="row masonary-layout">
          {galleryItems.map((item, index) => (
            <div key={index} className="col-xl-3 col-lg-6 col-md-6">
              <div className="gallery-one__single">
                <div className="gallery-one__img">
                  <img src={item.image} alt={item.alt} />
                  <div className="gallery-one__content">
                    <div className="gallery-one__sub-title-box">
                      <div className="gallery-one__sub-title-shape"></div>
                      <p className="gallery-one__sub-title">{item.category || "Next Super Model"}</p>
                    </div>
                    <h4 className="gallery-one__title">
                      <Link to={`/gallery/${item.slug}`}>{item.name}</Link>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
